<template>
	<div>
		<Breadcrumbs main="Service Management" title="Add Complaint" />
			<div class="container-fluid">
				<div class="row">
				   	<div class="col-sm-12">
						<div class="card">
							<div class="card-body">
	
								<div class="row mb-3">
									<div class="col-12">
										<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
									</div>
								</div>
	
								<form  @submit.prevent="addComplaint" enctype="multipart/form-data">
									<div class="form theme-form">
										<div class="row">
											<div class="col-md-3">
												<div class="mb-3 position-relative">
													<label class="control-label">Choose Device<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Search IMEI or Vehicle No or Mobile" v-model="device_id" @input="searchDevice" @focus="showSuggestions = true" @blur="hideSuggestions" autocomplete="off" />
													<div v-if="errors.device_id" class="text-danger">{{ errors.device_id }}</div>
													<ul v-if="showSuggestions && deviceSuggestions.length" class="list-group position-absolute w-100" style="z-index: 10; max-height: 200px; overflow-y: auto;">
														<li v-for="(dev, idx) in deviceSuggestions" :key="dev.imei" class="list-group-item list-group-item-action" @mousedown.prevent="selectDevice(dev)">
															<div><strong>{{ dev.imei }}</strong> - {{ dev.vehicle_number }} - {{ dev.mobile }}</div>
														</li>
													</ul>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
											<label class="control-label">Dealer</label>
													<div class="position-relative">
														<input
															class="form-control"
															type="text"
															placeholder="Search dealer..."
															v-model="dealerSearch"
															@input="searchDealer"
															@focus="showDealerSuggestions = true"
															@blur="hideDealerSuggestions"
															autocomplete="off"
														/>
														<ul v-if="showDealerSuggestions && filteredDealers.length" class="list-group position-absolute w-100" style="z-index: 10; max-height: 200px; overflow-y: auto;">
															<li v-for="dealer in filteredDealers" :key="dealer.id" class="list-group-item list-group-item-action" @mousedown.prevent="selectDealer(dealer)">
																{{ dealer.first_name }}
															</li>
														</ul>
													</div>
													<div v-if="selectedDealer" class="mt-2">
														<small class="text-success">
															<i class="icofont icofont-check-circled me-1"></i>
															Selected: <strong>{{ selectedDealer.first_name }}</strong>
														</small>
													</div>
													<div v-if="errors.dealer_id" class="text-danger">{{ errors.dealer_id }}</div>
												</div>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Complaint Type<span class="text-danger">*</span></label>
												<select class="form-select" v-model="complaint_type">
													<option value="">Select</option>
													<option value="1">SIM Change</option>
													<option value="2">Repair</option>
													<option value="4">No Data</option>
													<option value="5">Tracking Issue</option>
													<option value="6">Hardware Issue</option>
													<option value="7">Software Issue</option>
													<option value="8">Alert Fail</option>
													<option value="9">Other</option>
												</select>
												<div v-if="errors.complaint_type" class="text-danger">{{ errors.complaint_type }}</div>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Work Type<span class="text-danger">*</span></label>
												<select class="form-select" v-model="work_type">
													<option value="">Select</option>
													<option value="1">On Field</option>
													<option value="2">At Office</option>
												</select>
												<div v-if="errors.work_type" class="text-danger">{{ errors.work_type }}</div>
											</div>
										</div>

										<!-- Customer area -->
										<div class="row">
											<div class="col-md-3" v-if="!isNewCustomer">
												<div class="mb-3">
													<label class="control-label">Customer</label>
													<div class="position-relative">
														<input
															class="form-control"
															type="text"
															placeholder="Search customer..."
															v-model="customerSearch"
															@input="searchCustomer"
															@focus="showCustomerSuggestions = true"
															@blur="hideCustomerSuggestions"
															autocomplete="off"
														/>
														<ul v-if="showCustomerSuggestions && filteredCustomers.length" class="list-group position-absolute w-100" style="z-index: 10; max-height: 200px; overflow-y: auto;">
															<li v-for="cust in filteredCustomers" :key="cust.id" class="list-group-item list-group-item-action" @mousedown.prevent="selectCustomer(cust)">
																{{ cust.company_name }} - {{ cust.mobile }}
															</li>
														</ul>
													</div>
													<div v-if="selectedCustomer" class="mt-2">
														<small class="text-success">
															<i class="icofont icofont-check-circled me-1"></i>
															Selected: <strong>{{ selectedCustomer.company_name }} - {{ selectedCustomer.mobile }}</strong>
														</small>
													</div>
													<div class="mt-2">
														<a href="#" class="small" @click.prevent="isNewCustomer = true">+ Add new customer</a>
													</div>
													<div v-if="errors.company_id" class="text-danger">{{ errors.company_id }}</div>
												</div>
											</div>

											<!-- New customer inputs expanded (not cramped) -->
											<div class="col-md-3" v-if="isNewCustomer">
												<div class="mb-3">
													<label class="control-label">Customer Name<span class="text-danger">*</span></label>
													<input v-model="newCustomer.customer_name" class="form-control" placeholder="Enter customer name" />
													<div v-if="errors.customer_name" class="text-danger">{{ errors.customer_name }}</div>
												</div>
											</div>

											<div class="col-md-3" v-if="isNewCustomer">
												<div class="mb-3">
													<label class="control-label">Username (Mobile)<span class="text-danger">*</span></label>
													<input v-model="newCustomer.username" class="form-control" v-mobile-limit placeholder="Enter mobile number" maxlength="10" minlength="10" />
													<div v-if="errors.username" class="text-danger">{{ errors.username }}</div>
												</div>
											</div>

											<div class="col-md-3" v-if="isNewCustomer">
												<div class="mb-3">
													<label class="control-label">Password<span class="text-danger">*</span></label>
													<input v-model="newCustomer.password" type="password" class="form-control" placeholder="Enter password" />
													<div v-if="errors.password" class="text-danger">{{ errors.password }}</div>
													<div class="mt-2">
														<a href="#" class="small" @click.prevent="isNewCustomer = false; clearNewCustomerFields()">← Select existing customer</a>
													</div>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Vehicle Number<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="" v-model="vehicle_no"/>
													<div v-if="errors.vehicle_no" class="text-danger">{{ errors.vehicle_no }}</div>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Mobile</label>
													<input class="form-control" placeholder="" v-model="mobile" v-mobile-limit maxlength="10" minlength="10" />
													<div v-if="errors.mobile" class="text-danger">{{ errors.mobile }}</div>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Warrenty Upto</label>
													<input class="form-control" type="date" placeholder="" v-model="warranty_expiry"/>
													<div v-if="errors.warranty_expiry" class="text-danger">{{ errors.warranty_expiry }}</div>
												</div>
											</div>

											<div class="col-md-3" v-if="selectedDevice">
												<div class="mb-3">
													<label class="control-label">Warranty Status</label>
													<div class="form-check">
														<input class="form-check-input" type="checkbox" :checked="warranty_status === 1" @change="updateWarrantyStatus" id="warrantyStatus">
														<label class="form-check-label" for="warrantyStatus">
															<span class="badge" :class="warranty_status === 1 ? 'bg-success' : 'bg-danger'">
																{{ warranty_status === 1 ? 'Warranty Active' : 'Warranty Expired' }}
															</span>
														</label>
													</div>
												</div>
											</div>

										</div>

										<div class="row">
											<div class="col-12">
												<div class="mb-3">
													<label class="control-label">Complaint Details</label>
													<textarea class="form-control" placeholder="Enter complaint details" v-model="complaint_data"></textarea>
													<div v-if="errors.complaint_data" class="text-danger">{{ errors.complaint_data }}</div>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-12">
												<div class="mb-3 float-end">
													<label class="control-label">Assign to Speedtech</label>
													<div class="form-check">
														<label class="form-check-label" for="speedtechStatus">
															<span class="badge" :class="speedtech_status === 1 ? 'bg-success' : 'bg-danger'">
																{{ speedtech_status === 1 ? 'Assigned to Speedtech' : 'Not Assigned to Speedtech' }}
															</span>
														</label>
														<input class="form-check-input" type="checkbox" :checked="speedtech_status === 1" @change="updateSpeedtechStatus" id="speedtechStatus">
													</div>
												</div>
											</div>
										</div>
										<div class="row mt-3">
											<div class="col-sm-12">
												<button class="btn btn-success me-2 float-end" type="submit" :disabled="submitting">
													<span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
													{{ submitting ? "Saving..." : "Save" }}
												</button>
											</div>
										</div>
		
									</div>
								</form>
							</div>
						</div>
				   	</div>

					<div class="col-sm-12" v-if="selectedDevice">
						<div class="card">
							<div class="card-body">

								<div class="row">
									<div class="col-lg-12 col-md-12 mt-3">
										<div header-class="bg-transparent border-light" class="border border-light">
											<h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
												Complaint Logs</h4>

											<div class="table-responsive product-table">
												<table class="display" id="basic-1">
													<thead>
														<tr align="center">
															<th>Sl.No</th>  
															<th>Date</th>
															<th>Type</th>
															<th>Remarks</th>
															<th>Materials Used</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(log, idx) in device_logs" :key="idx" align="center">
															<td>{{ idx + 1 }}</td>
															<td>{{ log.date }}</td>
															<td>{{ log.type == 1 ? 'SIM Change' : log.type==2 ? 'Repair' : log.type==3 ? 'Replacemet' : 'N/A' }}</td>
															<td>{{ log.remarks }}</td>
															<td>
																<span v-if="log.materials && log.materials.length">
																	<span v-for="mat in log.materials" :key="mat.name">
																		{{ mat.name }} - {{ mat.qty }}<br>
																	</span>
																</span>
															</td>
														</tr>
														<tr v-if="device_logs.length === 0">
															<td colspan="5" class="text-center text-muted">No logs found.</td>
														</tr>
													</tbody>
												</table>
											</div>

										</div>
									</div>
								</div>

							</div>
						</div>
					</div>		
				</div>
			</div>
 
	</div>
 </template>

<script>
export default {
	name: "Add Campaign Page",
	

	data() {
		return {
			
			keyword: "",
			showsearch: false,
			listing_length: 10,
			token: "",
			submitting: false,
			errors: {},

			button_title: "Save",

			device_id: "",
			vehicle_no: "",
			mobile: "",
			warranty_expiry: "",
			warranty_status: 2, // Default to 2 (Warranty Expired)
			speedtech_status: 2, // Default to 2 (Not Assigned to Speedtech)
			complaint_data: "",
			complaint_type: "",
			work_type: "",
			searchTimeout: null,
			device_logs: [],
			deviceSuggestions: [],
			selectedDevice: null,
			showSuggestions: false,

			dealers: [],
			companies: [],
			dealerSearch: "",
			customerSearch: "",
			showDealerSuggestions: false,
			showCustomerSuggestions: false,
			selectedDealer: null,
			selectedCustomer: null,
			isNewCustomer: false,
			newCustomer: {
				customer_name: "",
				username: "",
				password: "",
			},
			

			
		};
	},
	computed: {
		filteredDealers() {
			if (!this.dealerSearch.trim()) return this.dealers;
			const q = this.dealerSearch.toLowerCase();
			return this.dealers.filter((d) => (d.first_name || "").toLowerCase().includes(q));
		},
		filteredCustomers() {
			if (!this.customerSearch.trim()) return this.companies;
			const q = this.customerSearch.toLowerCase();
			return this.companies.filter((c) => (c.company_name || "").toLowerCase().includes(q));
		},
	},
	created() {
		// this.addRow();

	},
	mounted() {
		const imei = this.$route.query.imei;
		if (imei) {
			this.device_id = imei;
			this.searchDevice();
		}
	},
	
	methods: {

		getToken() {
			if (localStorage.getItem('airotrack_staff')) {
				var airotrack_staff = JSON.parse(localStorage.getItem('airotrack_staff')); 
						
				if(airotrack_staff.token) {
					this.token = airotrack_staff.token;
					this.user = airotrack_staff;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		searchDevice() {
			this.getToken();
			if (!this.device_id.trim()) {
				this.deviceSuggestions = [];
				this.showSuggestions = false;
				return;
			}

			if (this.searchTimeout) clearTimeout(this.searchTimeout);

			this.searchTimeout = setTimeout(() => {
				const searchTerm = this.device_id.trim();

				this.$axios
					.get("staffs/deviceLists", {
						params: { keyword: searchTerm },
						headers: {
							Authorization: `Bearer ${this.token}`,
						},
					})
					.then((response) => {
						if (response.data.status === 'true') {
							this.deviceSuggestions = response.data.data;
							this.showSuggestions = true;
						} else {
							this.deviceSuggestions = [];
							this.showSuggestions = false;
						}
					})
					.catch((error) => {
						console.error("Error fetching device list:", error);
						this.deviceSuggestions = [];
						this.showSuggestions = false;
					});
			}, 300);
		},

		fetchDealers() {
			this.getToken();
			return this.$axios
				.get("/staffs/dealers", { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const data = res.data.data || res.data;
					this.dealers = Array.isArray(data) ? data : (data.data || []);
					return this.dealers;
				})
				.catch((err) => {
					console.log(err);
					this.dealers = [];
					return [];
				});
		},

		fetchCompanies() {
			this.getToken();
			return this.$axios
				.get("/staffs/companies", { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const data = res.data.data || res.data;
					this.companies = Array.isArray(data) ? data : (data.data || []);
					return this.companies;
				})
				.catch((err) => {
					console.log(err);
					this.companies = [];
					return [];
				});
		},

		searchDealer() {
			this.showDealerSuggestions = true;
		},
		hideDealerSuggestions() {
			setTimeout(() => { this.showDealerSuggestions = false; }, 200);
		},
		selectDealer(dealer) {
			this.selectedDealer = dealer;
			this.dealerSearch = dealer.first_name;
			this.showDealerSuggestions = false;
		},

		searchCustomer() {
			this.showCustomerSuggestions = true;
		},
		hideCustomerSuggestions() {
			setTimeout(() => { this.showCustomerSuggestions = false; }, 200);
		},
		selectCustomer(cust) {
			this.selectedCustomer = cust;
			this.customerSearch = cust.company_name;
			this.showCustomerSuggestions = false;
		},

		clearNewCustomerFields() {
			this.newCustomer.customer_name = "";
			this.newCustomer.username = "";
			this.newCustomer.password = "";
		},

		applyDeviceDefaultsFromLookup(device) {
			Promise.all([this.fetchDealers(), this.fetchCompanies()]).then(() => {
				if (device?.dealer_id) {
					const dealer = this.dealers.find((d) => d.id == device.dealer_id);
					if (dealer) {
						this.selectedDealer = dealer;
						this.dealerSearch = dealer.first_name;
					}
				}
				if (device?.company_id) {
					const cust = this.companies.find((c) => c.id == device.company_id);
					if (cust) {
						this.selectedCustomer = cust;
						this.customerSearch = cust.company_name;
					}
				}
			});
		},


		selectDevice(device) {
			this.device_id = device.imei || '';
			this.vehicle_no = device.vehicle_number || '';
			this.mobile = device.mobile || '';
			this.showSuggestions = false;
			this.deviceSuggestions = [];

			this.selectedDealer = null;
			this.selectedCustomer = null;
			this.dealerSearch = "";
			this.customerSearch = "";
			this.isNewCustomer = false;
			this.clearNewCustomerFields();
			this.applyDeviceDefaultsFromLookup(device);

			// Fetch logs and warranty info automatically
			if (device.vehicle_number) {
			this.getComplaintLogs(device.vehicle_number);
			}
		},

		getComplaintLogs(vehicle_number) {
			this.getToken();
			this.$axios
				.get("staffs/getComplaintLogs", {
					params: { vehicle_number },
					headers: {
						Authorization: `Bearer ${this.token}`,
					},
				})
				.then((response) => {
					if (response.data.status === 'true') {
						const data = response.data.data;

						// Fill warranty & vehicle data
						this.vehicle_no = data.vehicle_number || this.vehicle_no || '';
						// Only update mobile if API returns it
						if (data.mobile) {
							this.mobile = data.mobile;
						}
						this.warranty_expiry = data.warranty_upto;
						this.warranty_status =
							new Date(data.warranty_upto) >= new Date() ? 1 : 2;
						this.selectedDevice = {
							device_id: data.device_id,
							imei: data.imei,
							mobile: data.mobile || this.mobile,
						};

						this.applyDeviceDefaultsFromLookup(data);

						// Complaint logs
						this.device_logs = data.complaint_logs.map((log) => ({
							date: new Date(log.created_at).toLocaleDateString("en-GB"),
							type: log.service_type,
							remarks: log.remarks,
							materials: log.materials_used.map((mat) => ({
								name: mat.raw_material_name,
								qty: mat.quantity,
							})),
						}));
					} else {
						this.device_logs = [];
					}
				})
				.catch((error) => {
					console.error("Error fetching complaint logs:", error);
					this.device_logs = [];
				});
		},
	
		clearForm() {
			this.edit = false;
			this.errors = {};
		},

		addComplaint() {
			if (this.submitting) return;
			// Validate required fields
			this.errors = {};
			let isValid = true;

			if (!this.device_id || this.device_id.trim() === '') {
				this.errors.device_id = 'Device selection is required';
				isValid = false;
			}

			if (!this.complaint_type) {
				this.errors.complaint_type = 'Complaint type is required';
				isValid = false;
			}

			if (!this.work_type) {
				this.errors.work_type = 'Work type is required';
				isValid = false;
			}

			if (this.isNewCustomer) {
				if (!this.newCustomer.customer_name || !this.newCustomer.customer_name.trim()) {
					this.errors.customer_name = 'Customer name is required';
					isValid = false;
				}
				if (!this.newCustomer.username || !this.newCustomer.username.trim()) {
					this.errors.username = 'Username (mobile) is required';
					isValid = false;
				}
				if (!this.newCustomer.password || !this.newCustomer.password.trim()) {
					this.errors.password = 'Password is required';
					isValid = false;
				}
			}

			// if (!this.vehicle_no || this.vehicle_no.trim() === '') {
			// 	this.errors.vehicle_no = 'Vehicle number is required';
			// 	isValid = false;
			// }

			// if (!this.warranty_expiry) {
			// 	this.errors.warranty_expiry = 'Warranty expiry date is required';
			// 	isValid = false;
			// }

			// if (!this.complaint_data || this.complaint_data.trim() === '') {
			// 	this.errors.complaint_data = 'Complaint details are required';
			// 	isValid = false;
			// }

			if (!isValid) {
				return;
			}

			this.submitting = true;
			this.getToken();
			
			const formData = {
				imei	: this.device_id,
				service_type: this.complaint_type,
				vehicle_number: this.vehicle_no,
				mobile: this.mobile,
				warranty_expiry: this.warranty_expiry,
				warranty_status: this.warranty_status,
				work_type: this.work_type,
				to_speedtech: this.speedtech_status,
				details: this.complaint_data,
				dealer_id: this.selectedDealer ? this.selectedDealer.id : null,
				// Backend expects `customer_name` key; send empty string when customer is not provided
				customer_name: "",
			};

			if (this.isNewCustomer) {
				formData.customer_name = this.newCustomer.customer_name.trim();
				formData.username = this.newCustomer.username.trim();
				formData.password = this.newCustomer.password;
			} else {
				formData.company_id = this.selectedCustomer ? this.selectedCustomer.id : null;
				formData.customer_name = this.selectedCustomer
					? (this.selectedCustomer.customer_name || this.selectedCustomer.company_name || '')
					: "";
			}

			this.$axios
				.post('/staffs/addService', formData, {
					headers: {
						'Authorization': 'Bearer ' + this.token,
						'Content-Type': 'application/json'
					}
				})
				.then((response) => {
					if (response.status === 200) {
						this.$swal('Success', 'Complaint added successfully', 'success');
						this.$router.push({ name: 'complaint_management' });
					}
				})
				.catch((error) => {
					console.error('Error adding complaint:', error);
					this.$applyApiFieldErrors(this.errors, error);
					this.$swal('Error', this.$getApiErrorMessage(error, 'Failed to add complaint. Please try again.'), 'error');
				})
				.finally(() => {
					this.submitting = false;
				});
		},

	},
};

</script>